/***
 * Menu bar for client pages
 * Contains links to dashboard, profile, upload receipt, and logout button
 * Uses React Router's NavLink for navigation and active link styling
 */
import React, {useState} from "react";
import {NavLink, Outlet, useNavigate, Link} from "react-router-dom";
import { LayoutDashboard, TrendingUp, UserPen, LogOut, ListChevronsDownUp, ListChevronsUpDown, ReceiptText, Wallet} from "lucide-react";
import logo from '../logo.png';

const ClientLayout = ({setToken}) => {
    const navigate = useNavigate();

    const handleLogout = () => {
        setToken(null);
        navigate("/");
    };

    const [isOpen, setIsOpen] = useState(false);
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="min-vh-100">
            <nav className="p-4 custom-card navbar navbar-expand-lg flex flex-col h-screen fixed" style={{borderRadius: '0', borderLeft: 'none', borderRight: 'none', borderTop: 'none'}}>
                <div className="container-fluid" style={{maxWidth: '1400px'}}>
                    <Link to="/dashboard" className="navbar-brand">
                        <img src={logo} alt="Argus" style={{height: '70px'}}/>
                    </Link>
                    <button onClick={toggleMenu} className="navbar-toggler btn-outline-custom" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span >{isOpen ? <ListChevronsDownUp size={25}/> : <ListChevronsUpDown size={25}/>}</span>
                    </button>
                
                    <div className={`navbar-collapse ${isOpen ? '' : 'collapse'}`} id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item nav-item-custom">
                                {/* NavLink adds styling for the active link */}
                                <NavLink to="/dashboard" className={({ isActive }) => `btn d-flex align-items-center gap-2 ${isActive ? 'btn-primary-custom': 'btn-outline-custom'}`}>
                                    <LayoutDashboard size={16} /> Painel
                                </NavLink>
                            </li>
                            <li className="nav-item nav-item-custom">
                                <NavLink to="/price-control" className={({ isActive }) => `btn d-flex align-items-center gap-2 ${isActive ? 'btn-primary-custom': 'btn-outline-custom'}`}>
                                    <TrendingUp size={16} /> Controle de Preços
                                </NavLink>
                            </li>
                            <li className="nav-item nav-item-custom">
                                <NavLink to="/finance-control" className={({ isActive }) => `btn d-flex align-items-center gap-2 ${isActive ? 'btn-primary-custom': 'btn-outline-custom'}`}>
                                    <Wallet size={16} /> Controle Financeiro
                                </NavLink>
                            </li>
                            <li className="nav-item nav-item-custom">
                                <NavLink to="/upload-receipt" className={({ isActive }) => `btn d-flex align-items-center gap-2 ${isActive ? 'btn-primary-custom': 'btn-outline-custom'}`}>
                                    <ReceiptText size={16} /> Enviar Recibo
                                </NavLink>
                            </li>
                            <li className="nav-item nav-item-custom">
                                <NavLink to="/profile" className={({ isActive }) => `btn d-flex align-items-center gap-2 ${isActive ? 'btn-primary-custom': 'btn-outline-custom'}`}>
                                    <UserPen size={16} /> Perfil
                                </NavLink>
                            </li>
                        </ul>
                        <div className="nav-item nav-item-custom">
                            <button type="button" onClick={handleLogout} className="btn d-flex btn-outline-custom align-items-center gap-2">
                                <LogOut size={16} /> Sair
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
            <main className="">
                {/* The <Outlet> is where the content of the nested route will be rendered */}
                <Outlet />
            </main>
        </div>
    );
};

export default ClientLayout;